module.exports = __webpack_public_path__ + "img/service-06.37faa15a.svg";